export default {
  text_1_1: 'Hacer copias de seguridad nunca había sido tan simple y seguro.',
  text_1_2: 'Opciones mejoradas para satisfacer tus necesidades de privacidad.',
  text_2_1: 'Duradera, portátil y resistente a la flexión.',
  text_2_2: 'Protegida por CC EAL6+',
  text_2_3: 'Chip: llévala contigo a donde vayas.',
  text_2_4: 'Resistente a la flexión, a los imanes y a la electricidad estática.',
  text_2_5: 'Soporta hasta 500.000 pasadas de tarjeta.',
  text_3_1:
    'Impulsada por TokenPocket, disfruta de una experiencia de usuario perfecta al usar la KeyPal Card.',
  text_4_1: 'Compatible con código PIN para mejorar la seguridad',
  text_4_2:
    'La tarjeta se borrará automáticamente tras diez intentos consecutivos de PIN incorrecto.',
  text_4_3: 'No solo para copias de seguridad, también para firmas',
  text_4_4:
    'La versatilidad de la tarjeta va más allá de la copia de seguridad: también es un componente clave para la firma de transacciones.',
  text_4_5: 'NFC y copia de seguridad con un toque, simple y segura.',
  text_4_6: 'Activa un cifrado bidireccional veloz mediante campos electromagnéticos para copias de seguridad rápidas y sencillas.',
  text_5_1: 'Es hora de comenzar con tu',
  text_6_1: 'Billetera',
  text_6_2:
    'Integración perfecta para una experiencia de monedero sin igual, ¡donde cada KeyPal Card se conecta!',
  text_6_3: 'Copia de seguridad',
  text_6_4:
    'Haz que la copia de seguridad de tu billetera sea fácil y segura, eliminando el riesgo de pérdida de activos por respaldos incorrectos.',
  text_6_5: 'Firma',
  text_6_6:
    'Desbloquea usos diversos del monedero con tu KeyPal Card y realiza cada firma con facilidad.',
};
